var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoArtifactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.778 9.44466V9.11133C27.778 6.31106 27.778 4.91093 27.233 3.84138C26.7537 2.90056 25.9888 2.13566 25.0479 1.6563C23.9784 1.11133 22.5783 1.11133 19.778 1.11133H9.11133C6.31107 1.11133 4.91093 1.11133 3.84138 1.6563C2.90057 2.13566 2.13566 2.90056 1.6563 3.84138C1.11133 4.91093 1.11133 6.31106 1.11133 9.11133V26.4447C1.11133 29.2449 1.11133 30.645 1.6563 31.7146C2.13566 32.6554 2.90057 33.4203 3.84138 33.8997C4.91093 34.4447 6.31107 34.4447 9.11133 34.4447H15.278M24.4447 27.778V18.6113C24.4447 17.2306 25.5639 16.1113 26.9447 16.1113C28.3254 16.1113 29.4447 17.2306 29.4447 18.6113V27.778C29.4447 30.5394 27.2061 32.778 24.4447 32.778C21.6832 32.778 19.4447 30.5394 19.4447 27.778V21.1113",
    stroke: "#C1C6C8",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoArtifactIcon);
export default __webpack_public_path__ + "static/media/NoArtifactIcon.bbe759382cac5f11a055678e6b2aed1b.svg";
export { ForwardRef as ReactComponent };